'use client';

import { animated, useSpring } from '@react-spring/web';
import { useAtomValue } from 'jotai';

import { updateVersionState } from '@/api/common';
import { useLanguage } from '@/hooks/use-language';
import { commonLanguageAtom } from '@/store/language-store';
import CloseIcon from 'public/images/common/close.svg';
import SwitchVersionBg from 'public/images/common/switch-version-hint.svg';
import TriangleIcon from 'public/images/common/triangle.svg';

const Hint = ({
  visible,
  setVisible,
}: {
  visible: boolean;
  setVisible: (visible: boolean) => void;
}) => {
  const { currentLanguage } = useLanguage();
  const translateData = useAtomValue(commonLanguageAtom);

  const styles = useSpring({
    opacity: visible ? 1 : 0,
    display: visible ? 'flex' : 'none',
    boxShadow: 'rgba(0, 0, 0, 0.08) 0px 2px 20px 0px',
    delay: key => (key === 'display' ? 150 : 0),
  });

  return (
    <animated.div
      className="absolute top-[67px] z-[99] box-border flex items-center rounded-[12px] border-[1px] border-solid border-[rgba(0,0,0,0.06)] bg-white p-[12px] pr-[36px] text-[14px] leading-[24px]"
      style={{
        ...styles,
        width: currentLanguage === 'zh' ? '213px' : '290px',
        right: currentLanguage === 'zh' ? '100px' : '105px',
      }}
      {...({} as any)}>
      <TriangleIcon className="absolute right-0 top-[-8px]" />
      <SwitchVersionBg className="h-[32px] w-[32px]" />
      <div className="ml-[12px]">
        <p className="leading-[140%] text-[#CD292A]">
          {translateData['版本切换-浮窗-标题']}
        </p>
        <p className="leading-[140%]">{translateData['版本切换-浮窗-描述']}</p>
      </div>
      <CloseIcon
        onClick={() => {
          updateVersionState({
            events: [{ type: 'WEB_FLOAT_NOTICE' }],
          });
          setVisible(false);
        }}
        className="absolute right-[12px] top-1/2 translate-y-[-50%] cursor-pointer"
      />
    </animated.div>
  );
};

export default Hint;
